import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

/**
 * Pops the previous in-app history entry so the page behind keeps its state
 * (filters held in the query string, scroll position, and so on).
 *
 * React Router stamps `key: 'default'` on the entry the app was loaded with, so
 * that value means there is nothing of ours to pop — a deep link straight into
 * the page, e.g. from the Gaming Hub. Those fall back to the given path instead
 * of sending the user out of the app.
 */
export function useGoBack(fallback: string): () => void {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(() => {
    if (location.key === 'default') {
      navigate(fallback, { replace: true });
      return;
    }
    navigate(-1);
  }, [fallback, location.key, navigate]);
}
